var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRctLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 299,
    viewBox: "0 0 322 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M127.147 298.623L7.50229 178.979C2.66394 174.14 0 167.708 0 160.865C0 154.022 2.66451 147.59 7.50229 142.752L142.418 7.83683C152.406 -2.15166 168.656 -2.15166 178.645 7.83683L313.579 142.752C318.418 147.59 321.082 154.022 321.082 160.865C321.082 167.708 318.417 174.14 313.579 178.978L277.729 214.829L274.83 211.93L310.681 176.079C314.744 172.016 316.982 166.612 316.982 160.864C316.982 155.116 314.744 149.713 310.681 145.649L175.746 10.7355C167.357 2.34615 153.705 2.34615 145.316 10.7355L10.4009 145.65C2.01161 154.04 2.01161 167.691 10.4009 176.08L130.045 295.724L127.147 298.623Z",
    fill: "url(#paint0_linear_740_10571)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_10571",
    x1: 74.288,
    y1: 168.989,
    x2: 318.774,
    y2: 168.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRctLeft);
export default __webpack_public_path__ + "static/media/rctLeft.24c848ef57e603097518fb8f2cc5925c.svg";
export { ForwardRef as ReactComponent };